export const ProductComparison = "fa72cfc8b13814a210c82c441a08d15078301f28bfbb6b0a12be2cf7737083c7";